/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable import/no-dynamic-require */

import SemvWebgeoLogo from "./semv/webgeo.png";
import SemvIconLogo$ from "./semv/semv_icon.png";
import SemvLogo from "./semv/semv.png";
import MagnoVieiraLogo from "./magnovieira/magnovieria_fundo.png";
import MagnoVieiraIcon from "./magnovieira/magnovieira_icon.png";

import environments from "../../../environments";

const ClientLogo = /https:\/\//.test(environments.client.logo)
    ? environments.client.logo
    : require(`./clients/${environments.client.logo}`);

const ClientBrasao = /https:\/\//.test(environments.client.brasao as string)
    ? environments.client.brasao
    : require(`./clients/${environments.client.brasao}`);

const WebgeoLogo = window.location.host.includes("magnovieira")
    ? MagnoVieiraLogo
    : SemvWebgeoLogo;

const SemvIconLogo = window.location.host.includes("magnovieira")
    ? MagnoVieiraIcon
    : SemvIconLogo$;

const Logo = window.location.host.includes("magnovieira")
    ? MagnoVieiraLogo
    : SemvLogo;

export { WebgeoLogo, SemvIconLogo, Logo, ClientLogo, ClientBrasao };
